import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

// TODO 空实现
var NetInfo = function NetInfo() {
  _classCallCheck(this, NetInfo);

  _defineProperty(this, "_handleCallback", function () {});

  _defineProperty(this, "addEventListener", function () {
    return function () {};
  });

  _defineProperty(this, "removeEventListener", function () {});

  _defineProperty(this, "getConnectionInfo", function () {
    return new Promise(function (resolve, reject) {
      resolve();
    });
  });
};

export default new NetInfo();